import {patchState, signalStoreFeature, type, withMethods} from '@ngrx/signals';
import {GameFeatureInput} from './feature-input';

/**
 * Contributes tracking of whether a game-instructions `gm-modal` is currently
 * open, so other UI (like the map legend) can hide itself while the modal is
 * shown instead of risking being rendered on top of it.
 */
export function withInfoModal() {
  return signalStoreFeature(
    type<GameFeatureInput>(),
    withMethods((store) => ({
      /** Marks whether a game-instructions modal is currently open. */
      setInfoModalOpen(isOpen: boolean): void {
        patchState(store, {isInfoModalOpen: isOpen});
      },
    }))
  );
}
